var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNormalPrio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.667H5.83333C5.3731 11.667 5 12.0401 5 12.5003C5 12.9606 5.3731 13.3337 5.83333 13.3337H14.1667C14.6269 13.3337 15 12.9606 15 12.5003C15 12.0401 14.6269 11.667 14.1667 11.667Z",
    fill: "#009A4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 6.66699H5.83333C5.3731 6.66699 5 7.04009 5 7.50033C5 7.96056 5.3731 8.33366 5.83333 8.33366H14.1667C14.6269 8.33366 15 7.96056 15 7.50033C15 7.04009 14.6269 6.66699 14.1667 6.66699Z",
    fill: "#009A4F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalPrio);
export default __webpack_public_path__ + "static/media/normalPrio.fc8b2fce580f7bd456bab5eb132ba758.svg";
export { ForwardRef as ReactComponent };